module.exports = __webpack_public_path__ + "img/ray-pro.f9c934c5.jpg";